/**
 * Availability gate for the attachment reprocess (retry) feature.
 *
 * The retry affordance (C-4) is built ahead of the backend `POST
 * /api/attachments/{storageId}/reprocess` endpoint. Until that endpoint is
 * deployed (backend-core-v2 `attachment-error-mapping-and-reprocess`), the retry
 * controls MUST stay disabled and dispatch nothing — so the two changes can merge
 * independently without a broken button in prod.
 *
 * Flip the gate on by setting `REACT_APP_ATTACHMENT_REPROCESS_ENABLED=true` in the
 * environment once the endpoint is live — no code change / redeploy of logic needed.
 *
 * @returns {boolean} true when the reprocess endpoint is available and retry is enabled
 */
export const isReprocessEndpointAvailable = () =>
  process.env.REACT_APP_ATTACHMENT_REPROCESS_ENABLED === "true";
